import { useEffect } from 'react'
import { debugLog } from 'src/utils/debugLog'

const VersionChecker = () => {
  useEffect(() => {
    // Check for updates every 5 minutes
    const checkForUpdates = async () => {
      try {
        // Add a random query param to bypass cache
        const response = await fetch(`/meta.json?t=${new Date().getTime()}`, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        })
        const meta = await response.json()

        const currentVersion = localStorage.getItem('app_version')

        if (currentVersion && currentVersion !== meta.version) {
          // New version detected - force update immediately
          debugLog(`New version detected: ${meta.version} (current: ${currentVersion})`)

          // Clear all caches first
          if ('caches' in window) {
            const cacheNames = await caches.keys()
            await Promise.all(cacheNames.map(name => caches.delete(name)))
            debugLog('All caches cleared')
          }

          // Tell service worker to skip waiting and activate immediately
          if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations()
            for (const registration of registrations) {
              // If there's a waiting service worker, tell it to skip waiting
              if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' })
              }
              // Unregister the old service worker
              await registration.unregister()
            }
            debugLog('Service workers cleared')
          }

          // Update version in localStorage
          localStorage.setItem('app_version', meta.version)

          // Show user notification and reload
          if (window.confirm('A new version is available! The page will reload to get the latest updates.')) {
            window.location.reload(true)
          } else {
            // Even if user cancels, reload after 5 seconds to ensure updates
            setTimeout(() => {
              window.location.reload(true)
            }, 5000)
          }
        } else if (!currentVersion) {
          localStorage.setItem('app_version', meta.version)
          debugLog(`Version initialized: ${meta.version}`)
        }
      } catch (error) {
        console.error('Version check failed:', error)
      }
    }

    // Check on mount
    checkForUpdates()

    // Check every 5 minutes
    const interval = setInterval(checkForUpdates, 5 * 60 * 1000)

    return () => clearInterval(interval)
  }, [])

  return null
}

export default VersionChecker
